import React, { useEffect } from "react";
import "./style.scss";
import searchIcon from "../../assets/icons/search-white.svg";
import AccountsTable from "../../components/Accounts/AccountsTable";

function Accounts() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="accounts">
      <div className="accounts-header">
        <h2 className="component-heading">Prop Account </h2>
        <div className="search-wrapper">
          <input type="text" placeholder="Seacrh" />
          <img src={searchIcon} alt="" />
        </div>
      </div>

      <AccountsTable />
    </div>
  );
}

export default Accounts;
